'use client';

type PhaserModule = typeof import('phaser');

export function createBootScene(Phaser: PhaserModule) {
  return class BootScene extends Phaser.Scene {
    constructor() {
      super({ key: 'BootScene' });
    }

    create() {
      this.scene.start('LabScene');
      this.scene.launch('UIScene');
    }
  };
}
